import React from 'react';
import { Icon, IconButton, InputAdornment, Tooltip } from '@mui/material';

function SecretVisibilityToggle({ revealed, onToggle }) {
	return (
		<InputAdornment position="end">
			<Tooltip title={revealed ? 'Skjul værdi' : 'Vis værdi'}>
				<IconButton
					aria-label={revealed ? 'Skjul værdi' : 'Vis værdi'}
					onClick={onToggle}
					onMouseDown={ev => ev.preventDefault()}
					edge="end"
					size="small"
					tabIndex={-1}
				>
					<Icon fontSize="small">{revealed ? 'visibility_off' : 'visibility'}</Icon>
				</IconButton>
			</Tooltip>
		</InputAdornment>
	);
}

export default SecretVisibilityToggle;
